import type { QuotesFilters } from '../types';

/**
 * Query key factory for orders feature
 */
export const orderKeys = {
  all: ['orders'] as const,
  lists: () => [...orderKeys.all, 'list'] as const,
  list: (filters: QuotesFilters) => [...orderKeys.lists(), filters] as const,
  details: () => [...orderKeys.all, 'detail'] as const,
  detail: (id: string) => [...orderKeys.details(), id] as const,
  edit: (id: string) => [...orderKeys.all, 'edit', id] as const,
  stats: (filters?: { accountId?: string; salesManagerId?: string; status_in?: string[] }) =>
    [...orderKeys.all, 'stats', filters] as const,
  customers: () => [...orderKeys.all, 'customers'] as const,
  salesUsers: () => [...orderKeys.all, 'salesUsers'] as const,
  users: (orgId: string) => [...orderKeys.all, 'users', orgId] as const,
  subscriptions: (orgId: string) => [...orderKeys.all, 'subscriptions', orgId] as const,
  /** @deprecated Use subscriptions instead */
  contracts: (orgId: string) => [...orderKeys.all, 'subscriptions', orgId] as const,
};
